// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2Wf9p","productName":"Table_productName__uHcSy"};